module.exports = __webpack_public_path__ + "img/n-side-gray.f1d7e86f.svg";